import React, { Component } from 'react';
import { Form, Input } from 'antd';
import styles from '../../_style/index.less';
import { PopoverTip } from '@/components';
import { CHECK_number2 } from '@/shared/reqexp';
import { getState } from '@@/store';
/**
 * desc 修改排序
 * @params dataIndex
 * @params rowData
 * @params formTable : 整个表格的form 用以获取所有排序框数据
 * */
class TableCellIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
        };
    }
    changePopoverShow(validateItem) {
        const updateState = {};
        validateItem.errors && (updateState['validateMsg'] = validateItem.errors[0].message);
        updateState['validateState'] = !!validateItem.errors;
        return {
            msg: updateState.validateMsg || '',
            state: !!validateItem.errors,
        };
    }
    render() {
        const { dataIndex, rowData, formTable, editable } = this.props.td;
        const { getFieldDecorator } = formTable;
        const { validateIndexList } = getState().session;
        let validateMsg = '';
        let validateState = false;
        if (validateIndexList[rowData['goodsId']]) {
            const validate = this.changePopoverShow(validateIndexList[rowData['goodsId']]);
            validateMsg = validate.msg;
            validateState = validate.state;
        }
        return editable ? (<div className={styles.cell_editable}>
        <PopoverTip msg={validateMsg} direction={'right'} visible={validateState}>
          {rowData.status === 0 ? (<Form.Item help={''} style={{
            minHeight: 60,
            margin: 0,
            display: 'flex',
            justifyContent: 'center',
        }} className={styles.editable}>
                {getFieldDecorator(`${rowData['goodsId']}`, {
            initialValue: `${rowData[dataIndex]}`,
            rules: [
                {
                    pattern: CHECK_number2,
                    message: '请输入0至999的整数',
                },
            ],
        })(<Input style={{
            textAlign: 'center',
        }}/>)}
              </Form.Item>) : (<span>--</span>)}
        </PopoverTip>
      </div>) : (<React.Fragment>
        {this.props.children}
      </React.Fragment>);
    }
}
export default TableCellIndex;
